"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRefreshUserPermissionsEvent = exports.setFetchPermissionsEvent = exports.setFetchUserDataEvent = exports.setIsUserCriticalActionEvent = exports.setUserDataEvent = exports.setUserAuthentificateEvent = void 0;
var databus_1 = require("@portals/databus");
var constants_1 = require("./constants");
var setUserAuthentificateEvent = function (authenticated) {
    new databus_1.Databus({ name: constants_1.AUTHENTIFICATE_USER_STATE }).addEvent({
        detail: {
            authenticated: authenticated,
        },
    });
    databus_1.Databus.dispatchEvent({ eventName: constants_1.AUTHENTIFICATE_USER_STATE });
};
exports.setUserAuthentificateEvent = setUserAuthentificateEvent;
var setUserDataEvent = function (userData) {
    new databus_1.Databus({ name: constants_1.USER_DATA }).addEvent({
        detail: {
            userData: userData,
        },
    });
    databus_1.Databus.dispatchEvent({ eventName: constants_1.USER_DATA });
};
exports.setUserDataEvent = setUserDataEvent;
var setIsUserCriticalActionEvent = function (isCriticalAction) {
    new databus_1.Databus({ name: constants_1.USER_CRITICAL_ACTION }).addEvent({
        detail: {
            isCriticalAction: isCriticalAction,
        },
    });
    databus_1.Databus.dispatchEvent({ eventName: constants_1.USER_CRITICAL_ACTION });
};
exports.setIsUserCriticalActionEvent = setIsUserCriticalActionEvent;
var setFetchUserDataEvent = function () {
    new databus_1.Databus({ name: constants_1.FETCH_USER_DATA }).addEvent({
        detail: {},
    });
    databus_1.Databus.dispatchEvent({ eventName: constants_1.FETCH_USER_DATA });
};
exports.setFetchUserDataEvent = setFetchUserDataEvent;
var setFetchPermissionsEvent = function (options) {
    new databus_1.Databus({ name: constants_1.FETCH_PERMISSIONS }).addEvent({
        detail: options,
    });
    databus_1.Databus.dispatchEvent({ eventName: constants_1.FETCH_PERMISSIONS });
};
exports.setFetchPermissionsEvent = setFetchPermissionsEvent;
var setRefreshUserPermissionsEvent = function (options) {
    new databus_1.Databus({ name: constants_1.REFRESH_PERMISSIONS }).addEvent({
        detail: options,
    });
    databus_1.Databus.dispatchEvent({ eventName: constants_1.REFRESH_PERMISSIONS });
};
exports.setRefreshUserPermissionsEvent = setRefreshUserPermissionsEvent;
